module.exports = __webpack_public_path__ + "static/18-1b75eedcdbdc8f9d90d460a9ce5f4fd0.jpg";